import { AutoSuggestParams, AutoSuggestResponse } from 'components/shared/auto-suggest/Types';
import { NotNullValue, NullValue } from 'components/shared/list/filters/providers/Constants';
import EditRequestSource from '../types/__models__/EditRequestSource';
import AxiosHelper from './AxiosHelper';

class AutoSuggestService {
	private baseUrl: string;
	private suggestSlug: string;

	constructor(baseUrl: string, suggestSlugOverride) {
		this.baseUrl = baseUrl;
		this.suggestSlug = suggestSlugOverride || '/suggest';
	}

	/**
	 * Gets autosuggest options from the server based on user input
	 * @param query The value typed by the user used to filter the results on the server
	 *  searched that will not be included in the response
	 */
	public async getOptions(query: string, params?: AutoSuggestParams): Promise<AutoSuggestResponse> {
		const url = this.baseUrl + this.suggestSlug;
		const values: any = { ...params };

		if (query) {
			values.filter = query;
		}

		if (params && Array.isArray(params.ignoredIds) && params.ignoredIds.length > 0) {
			values.ignoredIds = params.ignoredIds.filter((i) => i !== NotNullValue && i !== NullValue);
		}

		try {
			const response = await AxiosHelper.post<AutoSuggestResponse>(url, values);

			response.data.records = response.data.records.map((record) => {
				record.isNewValue = true;
				return record;
			});

			return response.data;
		} catch (error) {
			throw error;
		}
	}

	/**
	 * Creates a new entity based on user input in an AutoSuggest field
	 * @param value The model that should be posted to the server
	 */
	public async createFromUserInput(value: any): Promise<any> {
		if (value) {
			value.editRequestSource = EditRequestSource.Suggest;
		}
		console.log('Creating:', value);

		try {
			const response = await AxiosHelper.post(this.baseUrl, value);
			return response.data;
		} catch (error) {
			throw error;
		}
	}
}

export default AutoSuggestService;
